export const PRIVACY_POLICY_MARKDOWN = `
<h5>**Introduction:**</h5>

dOrg, LLC (“hereinafter dOrg, collectively encompassing dorg.tech”) is committed to ensuring the privacy of all our users. We take our duty to process your personal data very seriously. This policy represents our commitment to your right to privacy, giving you a clear explanation about how we use your information and your rights over that information.

It's possible to use **dorg.tech**(“hereinafter website” or “us”)** **without submitting any personal information. For example, you can use Tor, plus a throwaway email, plus a VPN, plus a new pseudonym. If you care about preventing personal information from being collected on **dorg.tech**, then preventing this collection is **_your _**responsibility. 

<h5>**Scope of Privacy Policy:**</h5>

This privacy policy applies only to your use of our website, [dorg.tech](https://dorg.tech). Our website may contain links to other websites which are not hosted by us. Please note that we have no control over how your data is collected, stored, or used by other websites and we advise you to check the privacy policies of any such websites before providing any data to them.

**What types of information do we collect and how?**

The type and amount of information we receive and store depends on how you use the website. You can access most of the pages on the website without telling us who you are and without revealing any personal information.

Data protection laws require us to have a legal justification to process your personal information. We use the following depending on the type of data and the type of processing:

This data is used to:
\n * optimize the website, so that it's quick and easy to use.
\n * diagnose and debug technical errors

<h5>**Use of cookies:**</h5>
Our web servers use cookies and collect anonymous logs during user visits to the website which provide valuable information for improving the website in the future. 

A cookie is a text-only piece of information that a website transfers to your computer's hard disk so that the website can remember who you are. A cookie will normally contain the name of the Internet domain from which the cookie has come, the "lifetime" of the cookie, and a value, usually a randomly generated unique number.

**Types of Cookies Used:**

**Strictly Necessary Cookies-**

These cookies are essential in order to enable you to move around the website and use its features. Without these cookies, services such as remembering your login details cannot be provided.

**Session Cookies:**

Session cookies are temporary cookies which only exist during the time you use the website (or more strictly, until you close the browser after using the website). Session cookies allow users to be recognized within a website so any page changes or item or data selection you do is remembered from page to page.

Please note, our website may contain links to other websites which are not hosted by us. Please note that we have no control over how your data is collected, stored, or used by other websites and we advise you to check the privacy policies of any such websites before providing any data to them.

If you wish to restrict or block cookies you can set your internet browser to do so - click on the following link for more information: https://www.aboutcookies.org


<h5>**Sharing of data:**</h5>

In some circumstances your information may be shared with us by third parties, but only where you have specifically consented. 

We never sell user information to anyone.

In order to operate the site, the following data sharing occurs:

Our tech-related service providers necessarily have access to user data, and could collect/store data beyond what our website dorg.tech itself does. Service providers may or may not include, and are not limited to: Airtable, Netlify, Google Analytics, and Google Workspace. Please refer to their respective privacy policies. 


<h5>**Other sharing:**</h5>

We may also share your personal information with your permission, or if we are legally required to disclose your information in circumstances where this cannot be reasonably resisted.


<h5>**We collect personal information in the following ways:**:<h5/>

If you choose to provide it, namely through our “Join Us”, “Hire Us”, or subscribing to our “Newsletter”,  we can collect the following types of personal information from you: your name, your email, and your social media handle. Please keep in mind that you have no obligation or duty to provide us with any of this information when visiting our website.

<h5>**Consent:**:<h5/>

We require your consent to send you our communications, for example, to send you emails to update you on our work. We will only process your information in this way if you consent. 

<h5>**Legal obligation:**:<h5/>

We will process your personal information to fulfill any legal obligations placed upon us, through a lawfully valid legal order by a court of competent jurisdiction. 

<h5>**Jurisdiction:**<h5/>

Our website is under U.S. jurisdiction and is subject to U.S. federal and Vermont state laws, which may require us to do certain actions as required by valid subpoenas, wiretap orders, preservation orders (which would negate the above retention rules), and similar. Furthermore, our service providers could also be subject to similar orders without our knowledge. 

<h5>**Security:**<h5/>

We take appropriate security measures to ensure that we keep your information secure, accurate and up to date. However the transmission of information over the Internet is never completely secure, so while we do our best to protect personal information, we cannot guarantee the security of information transmitted to our websites.

<h5>**Hosting and processing arrangements:**<h5/>

Our websites are hosted by third party service providers and therefore any personal details you submit through them may be processed by that third party service provider. Please see the above for the third party service providers.

<h5>**Retention Period For Data:**<h5/>

We only hold your personal information on our systems for as long as is necessary for the purposes outlined above. We remove personal data from our systems once it is no longer required, in line with our guidelines on how long important information must remain accessible for future use or reference, as well as when and how data can be destroyed when it is no longer needed.

Users can also request all of their data that is collected including the right to be forgotten and all data removed.

<h5>**Access to and your rights over your personal information:**<h5/>

The personal data we hold about you is yours. You have the following rights over your information:

To be informed about how your data is being processed.

To access your data.

To rectify any data that is inaccurate.

To instruct us to delete your data.

To restrict our processing of your data (which includes contacting you via email) at any time. All our email communications to you will contain an unsubscribe link.

To object to your data being stored.

To remove your data.

<h5>**Complaints:**</h5>

If you wish to lodge a complaint about our handling of your personal data please get in touch with us on the details above with the details of your complaint; we aim to respond to all complaints within 14 working days. All legal requests will be reviewed by our legal department and appropriate action will be taken. If you have a legal request, please send an email to legal@dorg.tech with your request and it will be addressed by our legal department.`